__turbopack_context__.v({
  "container": "style-module-scss-module__7_ztGW__container",
  "image": "style-module-scss-module__7_ztGW__image",
});
